
// ********* Import CSS ***************** //

import "./media-events.css";

// ********* Import Images ***************** //

//*** ASATTC Spinner Image ***//
import "../assets/asattc-round-favicon/asattc-round-favicon.png";

// ** IMAGES ** //
import "../assets/asattc-media-images/asattc-chef-jack-savymhub-podcast.png";
import "../assets/asattc-media-images/asattc-wjcl-teen-culinary-program.jpg";
import "../assets/asattc-media-images/asattc-wtoc-battle-of-the-wings.jpg";

import "../assets/asattc-flyers/asattc-calling-all-chefs-competition-07-2024.jpg";
import "../assets/asattc-flyers/asattc-ex-something-event-oct-2024.jpg";
import "../assets/asattc-flyers/asattc-pick-up-fork-fundraiser-feb-2024.jpg";

// ********* Add Top Nav & Footer *************** //

import '../nav-header-footer/nav-header-footer.js';
import '../nav-header-footer/nav-header-footer.css';

// ************ Flyer Popup Modal ************ //
import '/src/popups/flyer-popup.js';
import '/src/popups/flyer-popup.css';

// ************ Add Email Signup *************** //

import '../nav-header-footer/email-contact-events.js';

// **************************** Spinner ****************************** //

$(window).on('load', function(){
  document.getElementById("spinner").style.display = "block";
  setTimeout(removeSpinner, 1000);
});

function removeSpinner(){
  $( "#spinner" ).fadeOut(100, function() {
    $( "#spinner" ).remove();
  });
}